import { request as http } from '@/utils/http'
import type { PageResponse } from '@/types/api'
import type {
  WarehouseAirPageRequest,
  WarehouseAirListVO,
  WarehouseAirDetailVO,
  BatchDeleteRequest,
  WarehouseAirBatchStatusRequest
} from './types'

// 新建保存空运运价
export const save = (params: Record<string, unknown>) => {
  return http.post<number>('/price/warehouse/air/save', params)
}

// 修改空运运价
export const update = (params: Record<string, unknown>) => {
  return http.post<boolean>('/price/warehouse/air/update', params)
}

// 分页查询空运运价
export const page = (params: WarehouseAirPageRequest) => {
  return http.post<PageResponse<WarehouseAirListVO>>('/price/warehouse/air/page', params)
}

// 获取空运运价详情
export const get = (id: string | number) => {
  return http.post<WarehouseAirDetailVO>('/price/warehouse/air/get', { id })
}

// 批量删除空运运价
export const batchDelete = (params: BatchDeleteRequest) => {
  return http.post<boolean>('/price/warehouse/air/batch-delete', params)
}

// 批量修改空运运价状态（启用/禁用）
export const batchUpdateStatus = (params: WarehouseAirBatchStatusRequest) => {
  return http.post<boolean>('/price/warehouse/air/batch-update-status', params)
}
